module.exports = __webpack_public_path__ + "static/media/rcsi.47ca097d.png";